import { FilesList } from './FilesList'
import { FileUploadButton } from './FileUploadButton'

interface Props {
  taskId: number
}

/** Sekcja "Pliki" w TaskDetailDrawer - lista załączników + przycisk uploadu. */
export function FilesSection({ taskId }: Props) {
  return (
    <div>
      <h4 className="mb-2 text-xs uppercase text-slate-500">Pliki</h4>
      <FilesList taskId={taskId} />
      <FileUploadButton taskId={taskId} />
    </div>
  )
}
